import React from "react";

import Accordion from "components/accordion";
import {useTranslation} from "react-i18next";

import "./FAQ.css";

const FAQ = () => {
    const {t} = useTranslation();

    return (
        <div className="faq">
            <div className="container">
                <p className="faq__title">
                    {t("FAQ")}
                </p>
                <Accordion/>
            </div>
        </div>
    )
}

export default FAQ